import classNames from "classnames";

const Nav = {
  data() {
    return {
      aside: false,
      menuLang: false,
      menuAccount: false,
      langAlert: false,
      sticky: false,
    }
  },

  mounted() {
    document.querySelector('body').classList.remove('overflow-hidden');
  },

  
  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const navClass = classNames("bg-primary z-50 w-screen" , this.sticky ? "sticky top-0" : "relative");

    return (
      <nav class={navClass}>


        <div class="z-10 relative bg-primary">
          <div class="container lg:px-6 mx-auto">
            <ul class="flex flex-wrap justify-around lg:justify-start h-full z-10 relative text-white text-sm lg:text-lg">
              <li class="flex mx-auto lg:mx-0 lg:mr-10 xl:mr-20 w-full lg:w-auto">
                <router-link to={{name: 'HomePage'}} class="flex items-center py-2 lg:py-4 mx-auto lg:mx-0">
                  <img src={'/img/logo_en.png'} alt="WHO regional office for Africa" class="h-10 lg:h-12"/>
                  <h1 class="text-sm lg:text-xl font-bold ml-6 text-white whitespace-no-wrap">
                    Change Management Simulation
                  </h1>
                </router-link>
              </li>
              
              
            </ul>
          </div>
        </div>
      </nav>
    );
  }
};


export default Nav;

